import listQuery from '../../../graphql/queries/company/FinancialPeriodsQuery.graphql';
import { Direction } from '../../schema/p4types';

const fpSort = () => {
  return {
    orderBy: 'startDate',
    orderDirection: Direction.Desc,
    first: 200, //Getting all financial periods should be no problem.
  };
};

const FinancialPeriod = {
  type: 'FinancialPeriod',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    customVariables: fpSort,
    remoteFilter: true,
  },
};

export default FinancialPeriod;
